<template>
    <div
        :ref="refId"
        class="ar-line-control"
        @mousedown="onMouseDown">
        <div 
            :style="calculateSize" 
            class="head"/>
    </div>
</template>

<script>
import { calculateLineHeadPosition } from './lib/utils';

export default {
    props: {
        refId: { type: String, default: '' },
        eventName: { type: String, default: '' },
        percentage: { type: Number, default: 0 },
        rowDirection: { type: Boolean, default: true }
    },
    computed: {
        calculateSize () {
            let value = this.percentage < 1 ? this.percentage * 100 : this.percentage;
            return `${this.rowDirection ? 'width' : 'height'}: ${value}%`;
        }
    },
    methods: {
        onMouseDown (ev) {
            let seekPos = calculateLineHeadPosition(ev, this.$refs[this.refId]);
            this.$emit('change-linehead', seekPos);
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onMouseUp);
        },
        onMouseUp (ev) {
            document.removeEventListener('mouseup', this.onMouseUp);
            document.removeEventListener('mousemove', this.onMouseMove);
            let seekPos = calculateLineHeadPosition(ev, this.$refs[this.refId]);
            this.$emit('change-linehead', seekPos);
        },
        onMouseMove (ev) {
            let seekPos = calculateLineHeadPosition(ev, this.$refs[this.refId]);
            this.$emit('change-linehead', seekPos);
        }
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
</style>
